module.exports = __webpack_public_path__ + "6bd4d7c9b3c4453a54c94479591df227.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/roguecompany/factory.png
// module id = 436
// module chunks = 0